export type SmartReviewGateKey =
  | 'accept_reviews'
  | 'accept_changeset'
  | 'accept_comparison'
  | 'accept_standalone'
  | 'accept_issue'
  | 'accept_pull'
  | 'accept_commit'
  | 'accept_git_comparison'
  | 'reprocess'
  | 'worker_review'
  | 'worker_assistant';

export interface SmartReviewGate {
  key: SmartReviewGateKey;
  paused: boolean;
  updatedBy?: string;
  updatedAt?: string;
}

export interface SmartReviewGatesResponse {
  gates: SmartReviewGate[];
}
